import loadCookieConsentModule from './modules/CookieConsent.module';
const loadReevooModule = () => ({
    hasRouter: false,
    modules: [loadCookieConsentModule()],
});
export default loadReevooModule;
